/// <reference path="wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    WPTNamespace.CONFIG_TYPE = "Config";
    const LOG_CATEGORY = "WPT.Config";
    WPTNamespace.DEFAULT_THEME_TAG = "##GATEWAY_DEFAULT##";
    const QUERYSTRING_APPLICATION = "application";
    const DEFAULT_RESOURCE_LOCATIONS = {
        "StandardDetailFiles": "./layouts/detail",
        "CustomDetailFiles": "./custom/layouts/detail"
    };
    const DEFAULT_ACCEPT_FILTER = ".doc, .docx, .pdf, image/*";
    let ConfigStages;
    (function (ConfigStages) {
        ConfigStages[ConfigStages["UNKNOWN"] = 0] = "UNKNOWN";
        ConfigStages[ConfigStages["INIT"] = 1] = "INIT";
        ConfigStages[ConfigStages["CONFIGSET"] = 2] = "CONFIGSET";
        ConfigStages[ConfigStages["APPSELECTED"] = 3] = "APPSELECTED";
        ConfigStages[ConfigStages["APPCONFIGLOADED"] = 4] = "APPCONFIGLOADED";
        ConfigStages[ConfigStages["READY"] = 5] = "READY";
    })(ConfigStages || (ConfigStages = {}));
    /**
     * Class holding configuration logic. Depends on WPT Loader "module".
     */
    class ConfigManager {
        constructor(core) {
            this._log = null;
            this._currentStage = ConfigStages.UNKNOWN;
            this._mainConfig = null;
            this._applicationList = null;
            this._visibleApplications = null;
            this._selectedApplication = null;
            this._applicationConfig = null;
            this._commonAppConfig = null;
            this._specificAppConfig = null;
            this._allowCurrentAppReload = null;
            this._selectedTheme = null;
            this.Type = WPTNamespace.CONFIG_TYPE;
            this.initLogging = () => {
                
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
            };
            /**
             * Get the main configuration data from config.json.
             * @returns configuration data from config.json
             */
            this.getMainConfig = () => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("ConfigManager.getMainConfig()");
                }
                else {
                    
                }
                return this._mainConfig;
            };
            /**
             * Get array of visible applications for the current user.
             * @returns array of visible applications
             */
            this.getVisibleApplications = () => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("ConfigManager.getVisibleApplications()");
                }
                else {
                    
                }
                return this._visibleApplications;
            };
            /**
             * Get configuration data for selected application.
             * @returns configuration data for selected application from config.json
             */
            this.getSelectedApplication = () => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("ConfigManager.getSelectedApplication()");
                }
                else {
                    
                }
                return this._selectedApplication;
            };
            /**
             * Get configuration data from application configuration file.
             * @returns configuration data from application configuration file
             */
            this.getApplicationConfig = () => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("ConfigManager.getApplicationConfig()");
                }
                else {
                    
                }
                return this._applicationConfig;
            };
            /**
             * Changes the application.
             * @param newApplication name of the application to choose
             * @returns 'true' if the application was found, otherwise 'false'
             */
            this.changeApplication = (newApplication) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("ConfigManager.changeApplication()");
                }
                else {
                    
                }
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("looking for application: " + newApplication);
                }
                else {
                    
                }
                let applicationFound = false;
                if (newApplication != null && newApplication != undefined && newApplication.length > 0) {
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("new application name provided");
                    }
                    else {
                        
                    }
                    if (this._allowCurrentAppReload || this._selectedApplication.Name.toUpperCase() != newApplication.toUpperCase()) {
                        if (this._log !== null && this._log.isTraceEnabled()) {
                            this._log.trace("new application name is not the selected or reload allowed");
                        }
                        else {
                            
                        }
                        let visibleLength = this._visibleApplications.length;
                        for (let i = 0; i < visibleLength; i++) {
                            if (this._visibleApplications[i].Name.toUpperCase() === newApplication.toUpperCase()) {
                                this._selectedApplication = this._visibleApplications[i];
                                applicationFound = true;
                                break;
                            }
                        }
                        if (applicationFound) {
                            if (this._log !== null && this._log.isTraceEnabled()) {
                                this._log.trace("selected application: " + this._selectedApplication.Name);
                            }
                            else {
                                
                            }
                            this._currentStage = ConfigStages.APPSELECTED;
                            if (this._log !== null && this._log.isTraceEnabled()) {
                                this._log.trace("current stage: " + ConfigStages[this._currentStage]);
                            }
                            else {
                                
                            }
                            this._loadSelectedApplication(true);
                        }
                    }
                }
                return applicationFound;
            };
            /**
             * Updates the available applications and checks whether the selected application is still valid.
             * @param switchToLogoffApplication decision whether the target application should be changed (for logoff)
             * @param switchToMappedApplication decision whether the target application should be changed (from mapping)
             * @returns information whether the application has been switched or not
             */
            this.updateApplications = (switchToLogoffApplication = false, switchToMappedApplication = false) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("ConfigManager.updateApplications()");
                }
                else {
                    
                }
                this._filterApplicationsByUsergroups();
                let targetApplication = this._selectedApplication.Name;
                let needsUpdate = false;
                if (switchToLogoffApplication) {
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("switching to logoff application, if necessary...");
                    }
                    else {
                        
                    }
                    targetApplication = this._getTargetApplication();
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("using target application: " + targetApplication);
                    }
                    else {
                        
                    }
                    needsUpdate = this._selectApplication(targetApplication, switchToLogoffApplication);
                }
                else if (switchToMappedApplication) {
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("switching to mapped application, if necessary...");
                    }
                    else {
                        
                    }
                    targetApplication = this._getMappedApplication();
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("using target application: " + targetApplication);
                    }
                    else {
                        
                    }
                    needsUpdate = this._selectApplication(targetApplication, switchToMappedApplication);
                }
                else {
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("no special handling...");
                    }
                    else {
                        
                    }
                    needsUpdate = this._selectApplication(targetApplication);
                }
                if (needsUpdate) {
                    this._currentStage = ConfigStages.APPSELECTED;
                    this._loadSelectedApplication(needsUpdate);
                }
                return needsUpdate;
            };
            /**
             * Gets the target application for logoff.
             * @returns name of the target application
             */
            this._getTargetApplication = () => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("ConfigManager._getTargetApplication()");
                }
                else {
                    
                }
                // first check application configuration
                if (this._applicationConfig.hasOwnProperty('LogoffApplication') && this._applicationConfig.LogoffApplication.length > 0) {
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("returning logoff application from config_application.json");
                    }
                    else {
                        
                    }
                    return this._applicationConfig.LogoffApplication;
                }
                // then check config.json
                if (this._mainConfig.hasOwnProperty('LogoffApplication') && this._mainConfig.LogoffApplication.length > 0) {
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("returning logoff application from config.json");
                    }
                    else {
                        
                    }
                    return this._mainConfig.LogoffApplication;
                }
                // fallback is current application
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("returning current application as logoff application");
                }
                else {
                    
                }
                return this._selectedApplication.Name;
            };
            this._getMappedApplication = () => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("ConfigManager._getMappedApplication()");
                }
                else {
                    
                }
                let result = this._selectedApplication.Name;
                let mapping = null;
                if (this._applicationConfig.hasOwnProperty('ApplicationMapping')) {
                    mapping = this._applicationConfig.ApplicationMapping;
                }
                else if (this._mainConfig.hasOwnProperty('ApplicationMapping')) {
                    mapping = this._mainConfig.ApplicationMapping;
                }
                if (mapping != null) {
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("application mapping configured");
                    }
                    else {
                        
                    }
                    let mappingApplied = false;
                    let mappingLength = mapping.length;
                    let usergroups = this._core.getCurrentUser().UserGroups;
                    for (let i = 0; i < mappingLength && !mappingApplied; i++) {
                        let appMapping = mapping[i];
                        let mappingGroupName = appMapping.UserGroup.toUpperCase();
                        if (usergroups.filter(group => group.Name.toUpperCase() === mappingGroupName).length > 0) {
                            result = appMapping.Application;
                            mappingApplied = true;
                            if (this._log !== null && this._log.isTraceEnabled()) {
                                this._log.trace("application mapping applied");
                            }
                            else {
                                
                            }
                        }
                    }
                }
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("returning application: " + result);
                }
                else {
                    
                }
                return result;
            };
            // Can't use setter because value type != getter type
            this.SelectTheme = (themeName, storeInProfile = false) => {
                this._selectedTheme = this.AvailableThemes.find(theme => theme.Name == themeName);
                if (this._selectedTheme) {
                    // TODO: Error handling!
                    this._core.Loader.resetCSS(this._selectedTheme.Location, false);
                    if (storeInProfile) {
                        // If we have profiles, save the theme (setting will silently fail if no user profile)
                        let themeSetting = `Theme:${this.getMainConfig().InstanceName}|${this.getSelectedApplication().Name}`.toUpperCase();
                        this._core.SetUserProfileConfigVar(themeSetting, themeName);
                    }
                    return true;
                }
                return false;
            };
            /**
             * Error callback for loading config.json.
             * @param url URL used for the attempt to get config.json
             * @param status status code for the attempt to get config.json
             * @param statusText status text for the attempt to get config.json
             */
            this._noConfigData = (url, status, statusText) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("ConfigManager._noConfigData()");
                }
                else {
                    
                }
                let msg = "failed to get config.json from '" + url + "': " + status + " - " + statusText;
                console.error(msg);
                // using alert, since basic functionality is not given
                alert(msg);
            };
            this._checkForRemoteConfigData = (configData) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("ConfigManager._checkForRemoteConfigData()");
                }
                else {
                    
                }
                if (configData.hasOwnProperty("RemoteConfig") && configData.RemoteConfig != null) {
                    if (!configData.hasOwnProperty("Server") || configData.Server == null) {
                        let msg = "Missing property 'Server' in config.json";
                        console.error(msg);
                        // using alert, since basic functionality is not given
                        alert(msg);
                    }
                    else {
                        this._core.setServer(configData.Server);
                        this._core.Loader.retrieveConfigData(configData.RemoteConfig, this._receiveRemoteGatewayConfig);
                    }
                }
                else
                    this._setConfigData(configData);
            };
            this._receiveRemoteGatewayConfig = (response) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("ConfigManager._receiveRemoteGatewayConfig()");
                }
                else {
                    
                }
                let configData = JSON.parse(response.ContentText);
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("Parsing and Setting from OnBase file");
                }
                else {
                    
                }
                this._setConfigData(configData);
            };
            /**
             * Callback for loading config.json.
             * @param configData configuration data from config.json
             */
            this._setConfigData = (configData) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("ConfigManager._setConfigData()");
                }
                else {
                    
                }
                this._mainConfig = configData;
                if (this._mainConfig.hasOwnProperty("Gateway")) {
                    // using slice to create a copy of the array in order to avoid changes in it
                    this._applicationList = this._mainConfig.Gateway.slice();
                }
                else {
                    this._applicationList = [];
                    let msg = "missing property 'Gateway' in config.json";
                    console.error(msg);
                    // using alert, since basic functionality is not given
                    alert(msg);
                }
                if (!this._mainConfig.hasOwnProperty('Server') || this._mainConfig.Server.length <= 0) {
                    let msg = "Server not configured";
                    console.error(msg);
                    // using alert, since basic functionality is not given
                    alert(msg);
                }
                // Default our resource locations in case they aren't set
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("Setting defaults for resource locations");
                }
                else {
                    
                }
                if (!this._mainConfig.hasOwnProperty('Resources')) {
                    this._mainConfig.Resources = {};
                }
                if (!this._mainConfig.Resources.hasOwnProperty('StandardDetailFiles')) {
                    this._mainConfig.Resources["StandardDetailFiles"] = DEFAULT_RESOURCE_LOCATIONS.StandardDetailFiles;
                }
                if (!this._mainConfig.Resources.hasOwnProperty('CustomDetailFiles')) {
                    this._mainConfig.Resources["CustomDetailFiles"] = DEFAULT_RESOURCE_LOCATIONS.CustomDetailFiles;
                }
                if (!this._mainConfig.hasOwnProperty('InstanceName') || !this._mainConfig.InstanceName) {
                    this._mainConfig.InstanceName = `${window.location.host}${window.location.pathname}`.replace('\index.html', '');
                }
                this._filterApplicationsByUsergroups();
                this._currentStage = ConfigStages.CONFIGSET;
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("current stage: " + ConfigStages[this._currentStage]);
                }
                else {
                    
                }
                // read query string parameter for application and select the one to use
                let queryApplication = this._core.getQueryStringValue(QUERYSTRING_APPLICATION);
                let needsQueryUpdate = this._selectApplication(queryApplication);
                this._currentStage = ConfigStages.APPSELECTED;
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("current stage: " + ConfigStages[this._currentStage]);
                }
                else {
                    
                }
                // load the selected application
                this._loadSelectedApplication(needsQueryUpdate);
            };
            /**
             * Filters the configured applications based on the user groups of the current user and stores the visible applications.
             */
            this._filterApplicationsByUsergroups = () => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("ConfigManager._filterApplicationsByUsergroups()");
                }
                else {
                    
                }
                this._visibleApplications = [];
                // using slice to create a copy of the array in order to avoid changes in it
                let applications = this._applicationList.slice();
                let userGroups = null;
                let currentUser = this._core.getCurrentUser();
                if (currentUser != null && currentUser != undefined) {
                    userGroups = currentUser.UserGroups;
                }
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("starting with applications: " + applications.map(g => g.Name));
                }
                else {
                    
                }
                let lastAddedWasBreak = false;
                let applicationsLength = applications.length;
                for (let a = 0; a < applicationsLength; a++) {
                    let application = applications[a];
                    if (application.hasOwnProperty("Name") && application.Name == "Break") {
                        // don't add rows of breaks
                        if (!lastAddedWasBreak) {
                            //add break to list
                            this._visibleApplications.push(application);
                            lastAddedWasBreak = true;
                        }
                    }
                    else {
                        let nextApplication = false;
                        let usergroupsLength = application.UserGroups.length;
                        for (let i = 0; i < usergroupsLength; i++) {
                            let applicationUsergroup = application.UserGroups[i];
                            // add applications open for all user groups
                            if (applicationUsergroup == "*") {
                                this._visibleApplications.push(application);
                                lastAddedWasBreak = false;
                                break;
                            }
                            applicationUsergroup = applicationUsergroup.toUpperCase();
                            if (userGroups != null && userGroups != undefined) {
                                // only add applications, which match the user groups of current user
                                let groupsLength = userGroups.length;
                                for (let j = 0; j < groupsLength; j++) {
                                    if (applicationUsergroup == userGroups[j].Name.toUpperCase()) {
                                        nextApplication = true;
                                        this._visibleApplications.push(application);
                                        lastAddedWasBreak = false;
                                        break;
                                    }
                                }
                                if (nextApplication) {
                                    break;
                                }
                            }
                        }
                    }
                }
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("using visible applications: " + this._visibleApplications.map(g => g.Name));
                }
                else {
                    
                }
            };
            /**
             * Select the application based on query string parameter and visible applications.
             * @param queryApplication query string parameter or 'undefined'
             * @param switchingApplications decision whether applications are switched or not
             * @returns decision whether the query string parameter needs an update
             */
            this._selectApplication = (queryApplication, switchingApplications = false) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("ConfigManager._selectApplication()");
                }
                else {
                    
                }
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("looking for application: " + queryApplication);
                }
                else {
                    
                }
                let applicationFound = false;
                let needsQueryUpdate = true;
                let visibleLength = this._visibleApplications.length;
                // first check given application
                if (queryApplication != null && queryApplication != undefined && queryApplication.length > 0) {
                    for (let i = 0; i < visibleLength; i++) {
                        let application = this._visibleApplications[i];
                        let applicationName = application.Name.toUpperCase();
                        if (this._log !== null && this._log.isTraceEnabled()) {
                            this._log.trace("looking at application: " + applicationName);
                        }
                        else {
                            
                        }
                        if (applicationName === queryApplication.toUpperCase()) {
                            if (this._log !== null && this._log.isTraceEnabled()) {
                                this._log.trace("application found");
                            }
                            else {
                                
                            }
                            if (!switchingApplications || applicationName === this._selectedApplication.Name.toUpperCase()) {
                                needsQueryUpdate = false;
                            }
                            this._selectedApplication = application;
                            applicationFound = true;
                            break;
                        }
                    }
                }
                // then check for first primary
                if (!applicationFound) {
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("checking for first primary application");
                    }
                    else {
                        
                    }
                    for (let i = 0; i < visibleLength; i++) {
                        let application = this._visibleApplications[i];
                        if (this._log !== null && this._log.isTraceEnabled()) {
                            this._log.trace("looking at application: " + application.Name);
                        }
                        else {
                            
                        }
                        if (application.hasOwnProperty('Primary') && application.Primary) {
                            if (this._log !== null && this._log.isTraceEnabled()) {
                                this._log.trace("first primary application found");
                            }
                            else {
                                
                            }
                            this._selectedApplication = application;
                            applicationFound = true;
                            break;
                        }
                    }
                }
                // falllback first application
                if (!applicationFound) {
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("no application found, taking the first one");
                    }
                    else {
                        
                    }
                    this._selectedApplication = this._visibleApplications[0];
                }
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("selected application: " + this._selectedApplication.Name);
                    this._log.trace("needs update? " + needsQueryUpdate);
                }
                else {
                    
                    
                }
                return needsQueryUpdate;
            };
            /**
             * Load the selected application and update query string parameter if necessary.
             * @param needsQueryUpdate decision whether the query string parameter needs an update
             */
            this._loadSelectedApplication = (needsQueryUpdate) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("ConfigManager._loadSelectedApplication()");
                }
                else {
                    
                }
                // set server from config.json or selected application
                if (this._selectedApplication.Server != null && this._selectedApplication.Server != undefined && this._selectedApplication.Server.length > 0) {
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("setting server from application configuration");
                    }
                    else {
                        
                    }
                    this._core.setServer(this._selectedApplication.Server);
                }
                else {
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("setting server from config.json");
                    }
                    else {
                        
                    }
                    this._core.setServer(this._mainConfig.Server);
                }
                // check whether the query string parameter needs an update
                if (needsQueryUpdate) {
                    this._core.changeQueryStringValue(QUERYSTRING_APPLICATION, window.encodeURIComponent(this._selectedApplication.Name));
                }
                this._applicationConfig = null;
                this._commonAppConfig = null;
                this._specificAppConfig = null;
                // load application configuration
                if (typeof this._selectedApplication.Config !== 'object') {
                    // load application configuration from given file location (URL)
                    this._core.Loader.getUnversionedJSON(this._selectedApplication.Config, this._setApplicationConfigData, this._noApplicationConfig);
                }
                else if (this._selectedApplication.Config.hasOwnProperty('Instance')) {
                    // load application configuration from OnBase
                    let confSpec = this._selectedApplication.Config;
                    let remoteSpec = {
                        Instance: confSpec.Instance,
                        FileType: 'APPLICATION',
                        Id: confSpec.Id
                    };
                    this._core.Loader.retrieveConfigData(remoteSpec, this._receiveRemoteApplicationConfig, this._noApplicationConfig);
                }
                else {
                    // load divided application configuration
                    let confSpec = this._selectedApplication.Config;
                    if (typeof confSpec.Common !== 'object') {
                        // load common application configuration from given file location (URL)
                        this._core.Loader.getUnversionedJSON(confSpec.Common, this._setCommonAppConfigData, this._noApplicationConfig);
                    }
                    else {
                        // load common application configuration from OnBase
                        let remoteSpec = {
                            Instance: confSpec.Common.Instance,
                            FileType: 'APPLICATION',
                            Id: confSpec.Common.Id
                        };
                        this._core.Loader.retrieveConfigData(remoteSpec, this._receiveRemoteCommonAppConfig, this._noApplicationConfig);
                    }
                    if (typeof confSpec.Specific !== 'object') {
                        // load specific application configuration from given file location (URL)
                        this._core.Loader.getUnversionedJSON(confSpec.Specific, this._setSpecificAppConfigData, this._noApplicationConfig);
                    }
                    else {
                        // load specific application configuration from OnBase
                        let remoteSpec = {
                            Instance: confSpec.Specific.Instance,
                            FileType: 'APPLICATION',
                            Id: confSpec.Specific.Id
                        };
                        this._core.Loader.retrieveConfigData(remoteSpec, this._receiveRemoteSpecificAppConfig, this._noApplicationConfig);
                    }
                }
            };
            this._receiveRemoteApplicationConfig = (response) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("ConfigManager._receiveRemoteApplicationConfig()");
                }
                else {
                    
                }
                let configData = JSON.parse(response.ContentText);
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("Parsing and Setting from OnBase file");
                }
                else {
                    
                }
                this._setApplicationConfigData(configData);
            };
            this._receiveRemoteCommonAppConfig = (response) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("ConfigManager._receiveRemoteCommonAppConfig()");
                }
                else {
                    
                }
                let configData = JSON.parse(response.ContentText);
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("Parsing and Setting from OnBase file");
                }
                else {
                    
                }
                this._setCommonAppConfigData(configData);
            };
            this._receiveRemoteSpecificAppConfig = (response) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("ConfigManager._receiveRemoteSpecificAppConfig()");
                }
                else {
                    
                }
                let configData = JSON.parse(response.ContentText);
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("Parsing and Setting from OnBase file");
                }
                else {
                    
                }
                this._setSpecificAppConfigData(configData);
            };
            /**
             * Error callback for loading application configuration.
             * @param url URL used for the attempt to get application configuration
             * @param status status code for the attempt to get application configuration
             * @param statusText status text for the attempt to get application configuration
             */
            this._noApplicationConfig = (url, status, statusText) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("ConfigManager._noApplicationConfig()");
                }
                else {
                    
                }
                let msg = "failed to get application configuration from '" + url + "': " + status + " - " + statusText;
                console.warn(msg);
                // using alert, since basic functionality is not given
                alert(msg);
            };
            /**
             * Callback for loading application configuration.
             * @param configData configuration data from application configuration
             */
            this._setApplicationConfigData = (configData) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("ConfigManager._setApplicationConfigData()");
                }
                else {
                    
                }
                this._applicationConfig = configData;
                if (configData.hasOwnProperty('AllowCurrentApplicationReload') && configData.AllowCurrentApplicationReload != null) {
                    this._allowCurrentAppReload = configData.AllowCurrentApplicationReload;
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("set allowCurrentAppReload to: " + this._allowCurrentAppReload);
                    }
                    else {
                        
                    }
                }
                this._setApplicationConfigDefaults();
                // Set the theme now we have the list of themes available
                // loading CSS files - moved down to after setServer
                // Check to see if the user has selected a theme for this application and load default otherwise
                let themeRequested = false;
                if (this._core.isUserLoggedIn()) {
                    themeRequested = this._core.Helper.requestTheme();
                }
                if (!themeRequested)
                    this._core.Loader.resetCSS(this._selectedApplication.CSS, false);
                this._currentStage = ConfigStages.READY;
                if (this._log !== null && this._log.isTraceEnabled()) {
                    this._log.trace("current stage: " + ConfigStages[this._currentStage]);
                }
                else {
                    
                }
                // let WPT know that we are ready
                this._core.moduleInitialisationFinished(this);
            };
            this._setApplicationConfigDefaults = () => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("ConfigManager._setApplicationConfigDefaults()");
                }
                else {
                    
                }
                if (!this._applicationConfig.hasOwnProperty('DefaultAcceptFilter')) {
                    this._applicationConfig.DefaultAcceptFilter = DEFAULT_ACCEPT_FILTER;
                }
            };
            /**
             * Callback for loading common application configuration.
             * @param configData configuration data from application configuration
             */
            this._setCommonAppConfigData = (configData) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("ConfigManager._setCommonAppConfigData()");
                }
                else {
                    
                }
                this._commonAppConfig = configData;
                if (this._specificAppConfig) {
                    this._mergeApplicationConfig();
                }
            };
            /**
             * Callback for loading specific application configuration.
             * @param configData configuration data from application configuration
             */
            this._setSpecificAppConfigData = (configData) => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("ConfigManager._setSpecificAppConfigData()");
                }
                else {
                    
                }
                this._specificAppConfig = configData;
                if (this._commonAppConfig) {
                    this._mergeApplicationConfig();
                }
            };
            this._mergeApplicationConfig = () => {
                if (this._log !== null && this._log.isInfoEnabled()) {
                    this._log.info("ConfigManager._mergeApplicationConfig()");
                }
                else {
                    
                }
                let appConf = this._core.Functions.mergeObjects(this._commonAppConfig, this._specificAppConfig);
                this._setApplicationConfigData(appConf);
            };
            
            this._core = core;
            this._currentStage = ConfigStages.INIT;
            this._allowCurrentAppReload = false;
            // load config.json and start handling of configuration data
            this._core.Loader.getUnversionedJSON('./config/config.json', this._checkForRemoteConfigData, this._noConfigData);
        }
        get AvailableThemes() {
            if (this._applicationConfig.hasOwnProperty('Themes') && this._applicationConfig.Themes) {
                return this._applicationConfig.Themes;
            }
            else if (this._mainConfig.hasOwnProperty('Themes') && this._mainConfig.Themes) {
                return this._mainConfig.Themes;
            }
            return [];
        }
        get SelectedTheme() {
            return this._selectedTheme;
        }
    }
    WPTNamespace.ConfigManager = ConfigManager;
})(WPTNamespace || (WPTNamespace = {}));
